<template>
  <div>

    <div>
      <el-form :inline="true" :model="searchFormData">
        <el-form-item>
          <el-input v-model="searchFormData.search" placeholder="输入名称搜索"></el-input>
        </el-form-item>
        <el-form-item label="项目选择">
          <el-select
              v-model="searchFormData.project_id" placeholder="全部"
                clearable
                filterable
                @change="selectProject"
                style="width:100%"
              >
              <el-option
                v-for="item in projectDataList"
                :key="item.project_id"
                :label="item.name"
                :value="item.project_id"
              />
          </el-select>
        </el-form-item>

        <el-form-item label="职位选择">
          <el-select
              v-model="searchFormData.job_id" placeholder="全部"
                clearable
                filterable
                style="width:100%"
              >
              <el-option
                v-for="item in jobDataList"
                :key="item.job_id"
                :label="item.title"
                :value="item.job_id"
              />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="abc">
      <div class="abc_left">
        <span>地址状态</span>
        <el-radio-group v-model="searchFormData.address_status" @change="changeStatus">
          <el-radio label="">全部</el-radio>
          <el-radio :label="2">待审核</el-radio>
          <el-radio :label="3">已审核</el-radio>
          <el-radio :label="4">申请调换</el-radio>
          <el-radio :label="5">拒绝调换</el-radio>

          <!--地址审核状态 1 无 忽略 2 待审核 3已审核 4 调换中 5 拒绝调换-->
        </el-radio-group>
      </div>
      <!--
      <div class="abc_right" v-if="1==2">
        <el-button type="text" v-if="!batchStatus"  @click="batch">批量操作</el-button>
        <el-button type="text" @click="completes" v-if="batchStatus" style=" font-size: 14px; margin-right:20px;">完成</el-button>
        <el-checkbox v-if="batchStatus" style="margin-right: 20px;" :checked="allstetus">
          全选
        </el-checkbox>
        <el-button type="text" v-if="batchStatus" style=" font-size: 14px; margin-right: 20px;" @click="batchInvite">邀请</el-button>
      </div>-->
    </div>

    <div class="middle">

      <AffrimItem  v-for="(item,index) in pageProps.records" 
        :key="index" 
        :obj="item" 
        :type="2"
        :batch="false"
      >   
      </AffrimItem>

     
    </div>
     <!--分页-->
     <div class="bottom">
      <div>
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" 
        :total="pageProps.total" :page-size="pageProps.pageSize" 
        :current-page="pageProps.pageNum" 
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" />
      </div>
   </div>

  </div>
</template>

<script>
import AffrimItem from '@/views/director/work/recruit/components/affrim-item.vue'
import { projectList} from "@/api/director/project/index.js";
import { jobList} from "@/api/director/job/index.js";
import { getAffirm} from "@/api/director/enroll/index.js";//recruitList,

export default {
  components: {
    AffrimItem
  },

  data () {
    return {
   

      pageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },

      searchFormData: {
        search: "",
        project_id: "",
        job_id:"",
        address_status: null, //地址审核状态 1 无 忽略 2 待审核 2 已审核 3 调换中 4 拒绝调换 默认 是全部
        page: 0,
        limit: 0,
      },

      projectDataList:[],
      jobDataList:[],

      flag:true,
    

    }
  },
  mounted () {
    this.initProjectList();
    this.initJobList();
    this.fetchData();
  },
  methods: {


    search(){
      this.fetchData();
    },

    changeStatus(){
      this.fetchData();
    },

    refreshData(){
      this.fetchData();

    },
    
    handleClick (tab, event) {
      console.log(tab, event);

    },


    selectProject(e){
      this.searchFormData.project_id=e;
      this.searchFormData.job_id=""
      this.initJobList();
    },


    fetchData () {
      var that = this;
      that.searchFormData.page = that.pageProps.pageNum;
      that.searchFormData.limit = that.pageProps.pageSize;

      getAffirm(that.searchFormData).then((response) => {
        console.log(response);
        that.pageProps.records = response.data.data;
        that.pageProps.total = response.data.total;
      });
    },

    //项目列表
    initProjectList(){
      var that = this;
      projectList({}).then((response) => {
        console.log('projectList',response);
        that.projectDataList = response.data;
      });
      
    },
    

    //职位列表


    initJobList(){
      var that = this;
      jobList({ project_id:this.searchFormData.project_id}).then((response) => {
        console.log('jobList',response);
        that.jobDataList = response.data;
      });
      
    },
    

    // 当前页变更
    handleCurrentChange (num) {
      this.pageProps.pageNum = num;
      this.fetchData();
    },

    // 每页显示页面数变更
    handleSizeChange (size) {
      this.pageProps.pageSize = size;
      this.fetchData();
    },

    batch(){
      this.flag=false
    },
    completes(){
      this.flag=true
    },


    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
     },
   
  },
}
</script>

<style lang="scss" scoped>
.abc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #999999;
  font-size: 14px;
  .abc_left {
    span {
      margin-right: 20px;
    }
  }
}
.middle {
  margin: 10px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height: 400px;

}
.bottom {
  width: 300px;
  margin-left: 336px;
}
</style>